const pxToRem = (px) => `${px / 16}rem`; // 1rem = 16px 基準
const splideEl = document.querySelector('.js-splide');

jQuery(function() {

if (splideEl) {
  // Splideのインスタンスを作成
  const splide = new Splide(splideEl, {
    autoplay: true, // 自動再生
    type: 'loop',
    rewind: true,
    pauseOnHover: false,
    interval: 5000,
    speed: 2000,
    padding: pxToRem(35),
    gap: pxToRem(-10),
    updateOnMove: true,
    arrows: false,
    pagination: false,
    drag: false,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        padding: pxToRem(200), // 16px → 1rem
        gap: pxToRem(-40), // -40px → -2.5rem
      },
    },
  });

  // Splideの初期化
  splide.mount();

  // リサイズ時に再初期化
  window.addEventListener('resize', () => {
    splide.destroy();
    splide.mount();
  });
}
});
